var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visibleBookmark)?_c('ExploreWorkspace',{attrs:{"token":_vm.token,"bookmark":_vm.visibleBookmark,"exportsVisible":_vm.exportsVisible,"shareVisible":_vm.shareVisible},on:{"open-bookmark":_vm.openBookmark,"export":_vm.exportWorkspace,"share":_vm.shareWorkspace,"event-clicked":_vm.eventClicked}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }